export default {
  screens: [
    {
      type: 'intro',
      title: '자연',
      content:
        '쇼메에게 끊임없이 풍부하고 상징적인 영감을 제공해 주는 자연은 메종의 역사와 함께한 중요한 테마입니다.',
      idYt: 'GUF98BCNd3c',
      videoCover: 'world/wild/video.jpg',
      desktop: {
        cover: 'world/wild/cover-1.jpg'
      },
      mobile: {
        cover: 'world/wild/mobile-cover-1.jpg',
        contentStyle: { width: '100%', paddingBottom: '120px' },
        coverStyle: {
          width: '110%',
          top: '87%',
          bottom: '40px',
          left: '0',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/wild/memento.jpg',
      content:
        ' 동물, 식물, 곤충은 장인들의 손끝에서 주얼리로 다시 태어나며, 원시 상태 그대로의 생동감 넘치는 아름다운 자연을 이야기합니다.<br><br> 마음껏 창의성을 펼칠 수 있는 식물을 테마로 한 쇼메의 주얼리는 차별화된 개성을 선사합니다.',
      cover: 'world/wild/cover-2.jpg',
      isCover: true
    },
    {
      type: 'staircase',
      desktop: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/cover-3.jpg'
      },
      mobile: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/mobile-cover-3.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '85%',
          top: '-15%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '조세핀이 선택했던 밀이삭은 풍요를 상징하며, 쇼메는 초창기에 바람에 가볍게 나부끼는 밀이삭을 모티브로 한 주얼리를 선보였습니다.  <br><br> 쇼메는 1811년에 선보인 에피 드 블레 티아라를 시작으로  밀이삭 모티브를 끊임없이 재해석하고 있습니다.',
      isCover: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/kr/worlds/wild.js